import { render, staticRenderFns } from "./discuss.vue?vue&type=template&id=2a8ceaa2&scoped=true&"
import script from "./discuss.vue?vue&type=script&lang=js&"
export * from "./discuss.vue?vue&type=script&lang=js&"
import style0 from "./discuss.vue?vue&type=style&index=0&id=2a8ceaa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8ceaa2",
  null
  
)

export default component.exports